
import axios from 'axios';

import { getAuthToken } from '../utils/authUtils'; //

const API_BASE = process.env.REACT_APP_FIREBASE_BACKEND_API_BASE || 'https://quantumleap-emr-dev.web.app';
/**
 * Secure Configuration Service
 * Uses backend API endpoints instead of direct Firestore access
 */

// Get configuration by type
export async function getConfiguration(configType) {
  try {
    const token = await getAuthToken();
    const response = await axios.get(`${API_BASE}/admin/configuration/${configType}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data;
    }

    throw new Error('Failed to get configuration');
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return null; // Configuration doesn't exist
    }
    console.error('Error getting configuration:', error);
    throw error;
  }
}

// Save configuration by type
export async function saveConfiguration(configType, configData) {
  try {
    const token = await getAuthToken();
    const response = await axios.put(`${API_BASE}/admin/configuration/${configType}`, configData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data;
    }

    throw new Error('Failed to save configuration');
  } catch (error) {
    console.error('Error saving configuration:', error);
    throw error;
  }
}

// Get workflow statistics
export async function getWorkflowStats(startDate, endDate) {
  try {
    const token = await getAuthToken();
    const response = await axios.get(`${API_BASE}/admin/workflow/stats`, {
      params: { 
        startDate: startDate.toISOString(), 
        endDate: endDate.toISOString() 
      },
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data;
    }

    throw new Error('Failed to get workflow stats');
  } catch (error) {
    console.error('Error getting workflow stats:', error);
    throw error;
  }
}

// Get all configuration types
export async function getAllConfigurations() {
  try {
    const token = await getAuthToken();
    const response = await axios.get(`${API_BASE}/admin/configuration`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data;
    }

    throw new Error('Failed to get configurations');
  } catch (error) {
    console.error('Error getting configurations:', error);
    throw error;
  }
}

// Delete configuration by type
export async function deleteConfiguration(configType) {
  try {
    const token = await getAuthToken();
    const response = await axios.delete(`${API_BASE}/admin/configuration/${configType}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data;
    }

    throw new Error('Failed to delete configuration');
  } catch (error) {
    console.error('Error deleting configuration:', error);
    throw error;
  }
}

// Reset configuration to defaults
export async function resetConfiguration(configType) {
  try {
    const token = await getAuthToken();
    const response = await axios.post(`${API_BASE}/admin/configuration/${configType}/reset`, {}, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data;
    }

    throw new Error('Failed to reset configuration');
  } catch (error) {
    console.error('Error resetting configuration:', error);
    throw error;
  }
}

// Get EDI configuration
export async function getEDIConfiguration() {
  try {
    const token = await getAuthToken();
    const response = await axios.get(`${API_BASE}/billing/edi/configuration`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data.configuration;
    }

    throw new Error('Failed to get EDI configuration');
  } catch (error) {
    console.error('Error getting EDI configuration:', error);
    throw error;
  }
}

// Get billing configuration
export async function getBillingConfiguration() {
  try {
    const token = await getAuthToken();
    const response = await axios.get(`${API_BASE}/billing/auto-billing/configuration`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data.configuration;
    }

    throw new Error('Failed to get billing configuration');
  } catch (error) {
    console.error('Error getting billing configuration:', error);
    throw error;
  }
}

// Save EDI configuration
export async function saveEDIConfiguration(ediConfig) {
  try {
    const token = await getAuthToken();
    const response = await axios.put(`${API_BASE}/billing/edi/configuration`, { configuration: ediConfig }, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data;
    }

    throw new Error('Failed to save EDI configuration');
  } catch (error) {
    console.error('Error saving EDI configuration:', error);
    throw error;
  }
}

// Save billing configuration
export async function saveBillingConfiguration(billingConfig) {
  try {
    const token = await getAuthToken();
    const response = await axios.put(`${API_BASE}/billing/auto-billing/configuration`, billingConfig, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data;
    }

    throw new Error('Failed to save billing configuration');
  } catch (error) {
    console.error('Error saving billing configuration:', error);
    throw error;
  }
}
